import type { HTMLAttributes } from 'react';

/**
 * Props that make an element and everything in it unreachable (no clicks,
 * focus or typing) while `on`: the HTML `inert` attribute. React 18 has no
 * typed prop for it and passes the string through.
 */
export function inertWhen(on: boolean): HTMLAttributes<HTMLElement> {
  return on ? ({ inert: '', 'data-inert': '' } as unknown as HTMLAttributes<HTMLElement>) : {};
}
